import { TextField, Tooltip } from "@mui/material";
import { FunctionComponent, useEffect, useState } from "react";

import styles from "../Calculator/css/calculateRow.module.css";

type PropsType = {
  label: string;
  totalMinutes: number;
  onChange: (totalMinutes: number) => void;
  tooltip?: string;
  disabled?: boolean;
};

const TimeField: FunctionComponent<PropsType> = ({
  label,
  totalMinutes,
  onChange,
  tooltip,
  disabled = false,
}) => {
  const [hoursStr, setHoursStr] = useState<string>(
    String(Math.floor(totalMinutes / 60)),
  );
  const [minutesStr, setMinutesStr] = useState<string>(
    String(totalMinutes % 60),
  );

  useEffect(() => {
    setHoursStr(String(Math.floor(totalMinutes / 60)));
    setMinutesStr(String(totalMinutes % 60));
  }, [totalMinutes]);

  const handleHoursChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    setHoursStr(raw);
    const h = parseInt(raw) || 0;
    const m = parseInt(minutesStr) || 0;
    onChange(h * 60 + m);
  };

  const handleMinutesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value;
    setMinutesStr(raw);
    const h = parseInt(hoursStr) || 0;
    const m = parseInt(raw) || 0;
    onChange(h * 60 + m);
  };

  const handleHoursBlur = () => {
    setHoursStr(String(parseInt(hoursStr) || 0));
  };

  const handleMinutesBlur = () => {
    setMinutesStr(String(parseInt(minutesStr) || 0));
  };

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.container__content}`}>
        <div
          className={`${styles.container__title}`}
          style={{ minWidth: "250px" }}
        >
          <Tooltip title={tooltip || ""} disableInteractive>
            <span style={{ margin: "0 4px 0 0" }}>{label}</span>
          </Tooltip>
        </div>
        <div className={`${styles.content}`}>
          <TextField
            sx={{ backgroundColor: "white", width: "60px" }}
            size="small"
            type="number"
            inputProps={{ placeholder: "h", min: 0, max: 100 }}
            value={hoursStr}
            onChange={handleHoursChange}
            onBlur={handleHoursBlur}
            disabled={disabled}
          />
          <Tooltip title={"h:mm"} disableInteractive>
            <span style={{ margin: "0 4px" }}>:</span>
          </Tooltip>
          <TextField
            sx={{ backgroundColor: "white", width: "70px" }}
            size="small"
            type="number"
            inputProps={{ placeholder: "mm", min: 0, max: 59 }}
            value={minutesStr}
            onChange={handleMinutesChange}
            onBlur={handleMinutesBlur}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default TimeField;
